import { Component, OnInit, Input, Output, EventEmitter, input } from '@angular/core';
import { Image } from '@frontend/core';
import { UserExtraLite } from '@frontend/common';


@Component({
  selector: 'frontend-link-type-four',
  templateUrl: './link-type-four.component.html',
  styleUrls: ['./link-type-four.component.scss'],

  standalone: false,
})
export class LinkTypeFourComponent implements OnInit {

  // Good for internal links/actions where the model has an image

  @Input() title : string;
  @Input() description : string;
  @Input() date : Date;
  image = input<Image>();
  @Input() users : UserExtraLite[];
  @Input() user_list_prefix_translation : string; // 'TOOLS.ADDED_BY'
  @Input() slug : string;
  @Input() cta_translation : string;
  @Output() linkClicked = new EventEmitter<any>();
  thumbnailImageTransformation : string = 'c_thumb,w_700/';

  constructor() { }

  doLinkClick (){
    this.linkClicked.emit();
  }

  ngOnInit(): void {
  }

}
